// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__1rwk8","isOpen":"Menu_isOpen__2ot64","disabled":"Menu_disabled__Qvk3n"};